import { request } from "../utils/request";

const noticeApi = {
    // 获取公告列表
    getAllNotice(data) {
        return request({
            method: "POST",
            url: "/api/notice/noticeManage/getAllNotice",
            data
        });
    },
    // 删除公告（可批量）
    deleteNotice(data) {
        return request({
            method: "POST",
            url: "/api/notice/noticeManage/deleteNotice",
            data
        });
    },
    // 查看公告
    noticePreview(data) {
        return request({
            method: "POST",
            url: "/api/notice/noticeManage/noticePreview",
            data
        });
    },
    // 查询科室列表
    getSectionInfo(data) {
        return request({
            method: "POST",
            url: "/api/ksgl/managestudent/getSectionInfo",
            data
        });
    },
    // 查询职称列表
    getPTitleInfo(data) {
        return request({
            method: "POST",
            url: "/api/ksgl/managestudent/getPTitleInfo",
            data
        });
    },
    // 新增公告
    addNotice(data) {
        return request({
            method: "POST",
            url: "/api/notice/noticeManage/addNotice",
            data
        });
    },
    // 获取分组列表
    groupList(data) {
        return request({
            method: "POST",
            url: "/api/ksgl/groupManage/groupList",
            data
        });
    },
    // 获取考生列表
    getStudentList(data) {
        return request({
            method: "POST",
            url: "/api/ksgl/manageStudent/getStudentList",
            data
        });
    },
}

export default noticeApi;